import { Modal } from "@/components/elements/Modal";
import { DATA_CONFLICT_MESSAGE } from "@/constants/common";
import { replaceStr } from "@/utils/string";
import { Typography } from "@mui/material";
import { FC } from "react";

type TDataConflictModalProps = {
  open: boolean;
  name: string;
  onConfirm: () => void;
  onCancel: () => void;
};

// Optimistic-concurrency conflict dialog: cancel keeps the stale form open, reload refetches the screen.
export const DataConflictModal: FC<TDataConflictModalProps> = ({ open, name, onConfirm, onCancel }) => (
  <Modal
    isOpen={open}
    width={500}
    onOk={onConfirm}
    onClose={onCancel}
    labelClose="キャンセル"
    labelOk="リロードする"
    enableCloseIcon={false}
    preventCloseBackdrop
  >
    <Typography variant="body14" component="p" sx={{ py: 2, whiteSpace: "pre-line" }}>
      {replaceStr(DATA_CONFLICT_MESSAGE, { name })}
    </Typography>
  </Modal>
);
